import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, Tooltip, DatePicker } from "antd";
import moment from "moment";
import ActionBar from "../../components/action-bar";
import FlexCard from "../../components/flex-card";
import MiniTable from "../../components/mini-table";
import AuthenticatedLayout from "../../layouts/authenticated";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import BreadcrumbTitulo from "@/components/breadcrumb-titulo";
import ResumoTable from "./_ResumoTable";

const DATE_DISPLAY = "DD/MM/YYYY";

export default function ResumoDiarioPage() {
  const { t } = useTranslation();

const miniTableRefs = {
  RESUMO: useRef(),
  DOCUMENTOS: useRef(),
  TAREFAS: useRef(),
};


  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [dataSourceModulos, setDataSourceModulos] = useState([]);
  const [dataSourceArmazenamentos, setDataSourceArmazenamentos] = useState([]);
  const [dataSourceTarefas, setDataSourceTarefas] = useState([]);
  const [activeTab, setActiveTab] = useState("RESUMO");
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(moment().subtract(7, "days")); 
  const [endDate, setEndDate] = useState(moment()); 
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleSearch = (searchTerm) => {
    setLoadingSearch(true);

    unwrapAxiosPromise(
      axios.get("/dataAnalytics/resumo", {
        params: {
          search: searchTerm,
          startDate: startDate.format("YYYY-MM-DD"),
          endDate: endDate.format("YYYY-MM-DD"),
        },
      })
    )
      .then((data) => {
        setDataSourceModulos(data.modulos || []);
        setDataSourceArmazenamentos(data.armazenamentos || []);
        setDataSourceTarefas(data.tarefas || [])
      })
      .finally(() => setLoadingSearch(false));
  };

  useEffect(() => {
    handleSearch(search);
  }, [startDate, endDate, search]);

  const renderDatePicker = (value, onChange, placeholder, customStyle = {}) => (
    <DatePicker
      value={value} 
      onChange={(date) => onChange(date || moment())} 
      onOpenChange={(open) => setIsPickerOpen(open)}
      format={DATE_DISPLAY}
      allowClear={false}
      inputReadOnly
      placeholder={t(placeholder)}
      style={{ cursor: "pointer", width: 130, ...customStyle }}
    />
  );

  return (
    <AuthenticatedLayout breadcrumb={[t("Resumo Diário")]} >
      <FlexCard
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <BreadcrumbTitulo selected={t("Resumo Diário")} />

            <ActionBar onSearch={(value) => setSearch(value)}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginRight: 8 }}>
                <Tooltip title={t("Data de início")}>
                  {renderDatePicker(startDate, setStartDate, "Data inicial", { marginLeft: -5 })}
                </Tooltip>
                <Tooltip title={t("Data de fim")}>
                  {renderDatePicker(endDate, setEndDate, "Data final")}
                </Tooltip>
              </div>
   <MiniTable.DownloadButton
  disabled={loadingSearch || loadingRemove}
  miniTableRef={miniTableRefs[activeTab]}
  customFileName={
    activeTab === "RESUMO" 
      ? "resumoModulos" 
      : activeTab === "DOCUMENTOS"
        ? "resumoArmazenamento"
        : "resumoTarefas"
  }
/>
            </ActionBar>
          </div>
        }
        headStyle={{ backgroundColor: "#f0f0f06b" }}
      >
<Tabs
  activeKey={activeTab}
  onChange={(k) => setActiveTab(k)}
  items={[
    {
      key: "RESUMO",
      label: t("Módulos"),
      children: (
        <ResumoTable
          dataSource={dataSourceModulos}
          loading={loadingSearch || loadingRemove}
          miniTableRef={miniTableRefs.RESUMO}
        />
      ),
    },
    {
      key: "DOCUMENTOS",
      label: t("Armazenamento"),
      children: (
        <ResumoTable
          dataSource={dataSourceArmazenamentos}
          loading={loadingSearch || loadingRemove}
          miniTableRef={miniTableRefs.DOCUMENTOS}
        />
      ),
    },
    {
      key: "TAREFAS",
      label: t("Tarefas"),
      children: (
        <ResumoTable
          dataSource={dataSourceTarefas}
          loading={loadingSearch || loadingRemove}
          miniTableRef={miniTableRefs.TAREFAS}
        />
      ),
    },
  ]}
/>

      </FlexCard>
    </AuthenticatedLayout>
  );
}
